/**
 * Extracts a single numeric value from a MUI Slider onChange event safely,
 * eliminating the need for repeated `v as number` casts throughout the codebase.
 */
export function sliderValue(v: number | number[]): number {
    return Array.isArray(v) ? v[0] : v;
}
